import { useThemeContext } from "@pineseed/gui/provider/theme";

/**
 * Theme hook — delegates to ThemeProvider context.
 * All theme state and DOM effects are managed by ThemeProvider.
 */
export function useTheme() {
  return useThemeContext();
}
